import { Reveal } from "./motion";

const questions = [
  {
    n: "01",
    q: "What did they say that you never followed up on?",
    a: "Name the detail, concern, goal, or opportunity that you let pass.",
  },
  {
    n: "02",
    q: "Where did you stop listening and start performing?",
    a: "Name the exact moment you started planning your response or trying to sound impressive.",
  },
  {
    n: "03",
    q: "What meaningful next step did you create?",
    a: "A resource, introduction, invitation, follow-up, or 30-minute Deeper Conversation.",
  },
];

export const Debrief = () => {
  return (
    <section className="border-y-2 border-ink bg-white py-20 md:py-28" data-testid="debrief-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <div className="mb-14 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.22em] text-ink/50">
                After the conversation
              </p>
              <h2 className="font-display text-4xl font-black uppercase tracking-tight text-ink sm:text-5xl lg:text-6xl">
                Three questions.
              </h2>
            </div>
            <p className="max-w-sm text-base leading-relaxed text-ink/60">
              Answer them honestly. The honest answers are the only ones that can improve the next
              conversation.
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {questions.map((item, i) => (
            <Reveal key={item.n} delay={i * 0.1}>
              <div className="flex h-full flex-col border-2 border-ink bg-cloud p-7 md:p-8" data-testid={`debrief-${item.n}`}>
                <span className="font-display text-6xl font-black leading-none text-ink/15 md:text-7xl">{item.n}</span>
                <h3 className="mt-4 font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-ink md:text-2xl">
                  {item.q}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-ink/70">{item.a}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <div className="mt-6 border-l-4 border-acid bg-cloud p-6 md:p-8">
            <p className="mb-2 font-mono text-xs font-bold uppercase tracking-[0.18em] text-ink/50">
              The honest part
            </p>
            <p className="max-w-4xl text-lg leading-relaxed text-ink md:text-xl">
              If you cannot answer question one, you were waiting. If you cannot answer question three, the
              relationship may not have a clear next step yet, and that is okay.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
